import React, { useEffect, useRef } from 'react';
import api from '../utils/api';

const POLL_MS = 30000;

const AdminOrderNotifier: React.FC = () => {
  const lastSeenOrderIdRef = useRef<string | null>(null);
  const isActiveRef = useRef<boolean>(true);

  useEffect(() => {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission().catch(() => {});
    }

    const checkForNewOrders = async () => {
      try {
        const { data } = await api.get('/api/orders/admin/all', { params: { page: 1, limit: 1 } });
        const latest = data?.orders?.[0];
        if (!latest) return;

        if (lastSeenOrderIdRef.current === null) {
          lastSeenOrderIdRef.current = latest._id;
          return;
        }

        if (latest._id !== lastSeenOrderIdRef.current) {
          lastSeenOrderIdRef.current = latest._id;
          if ('Notification' in window && Notification.permission === 'granted') {
            const name = [latest.customerInfo?.firstName, latest.customerInfo?.lastName].filter(Boolean).join(' ') || 'ضيف';
            const total = typeof latest.totalAmount === 'number' ? latest.totalAmount.toFixed(2) : latest.totalAmount;
            const n = new Notification('طلب جديد', {
              body: `طلب جديد بقيمة ₪${total} من ${name}`,
              icon: '/favicon.ico'
            });
            setTimeout(() => n.close(), 5000);
          }
        }
      } catch (e) {
        // ignore
      }
    };

    checkForNewOrders();
    const id = setInterval(() => {
      if (isActiveRef.current) checkForNewOrders();
    }, POLL_MS);

    return () => {
      isActiveRef.current = false;
      clearInterval(id);
    };
  }, []);

  return null;
};

export default AdminOrderNotifier;


